import React from 'react';
import { FormattedMessage } from 'react-intl';

import { GIButton, Modal } from 'app-components';

import { ModalContextType } from '../../../contexts/modalContext';
import CapitalizedButton from '../components/common/CapitalizedButton';

interface IModalProps extends ModalContextType {
    setActiveTab: (tab: number) => void;
}

export default function HealthBeforeDentalModal({ closeModal, setActiveTab }: IModalProps) {
    function onClose(e) {
        e?.preventDefault();
        closeModal('healthBeforeDentalModal');
    };

    function onContinueWithHealth(e) {
        setActiveTab(0);
        onClose(e);
    }

    return (
        <Modal id="healthBeforeDentalModal">
            <Modal.Header id="healthBeforeDentalModalHeader" titleId="customGrouping.customGrouping" onHide={onContinueWithHealth} />
            <Modal.Body id="healthBeforeDentalModalBody">
                <p>
                    <FormattedMessage id="customGrouping.healthEnrollPriorDental" />
                </p>
            </Modal.Body>
            <Modal.Controls>
                <CapitalizedButton 
                    id="healthBeforeDentalModalContinueButton" 
                    variant="secondary" 
                    onClickHandler={onContinueWithHealth} 
                    labelId="customGrouping.continueWithHealth" 
                />
                <CapitalizedButton 
                    id="healthBeforeDentalModalStartButton" 
                    variant="secondary" 
                    onClickHandler={onClose} 
                    labelId="customGrouping.startDentalShopping" 
                    leftMargin={true} 
                />
            </Modal.Controls>
        </Modal>
    );
}
